module.exports = __webpack_public_path__ + "static/media/layout-1.5b223e8d.svg";